import { defineComponent as l, inject as t, computed as c, provide as m, createElementBlock as u, openBlock as f, mergeProps as b, unref as e, createElementVNode as S, normalizeClass as y, renderSlot as P } from "vue";
import o from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Page/page.js";
import { PageSidebarOpenKey as g, PageManagedSidebarKey as v } from "./Page.vue2.js";
import { useOUIAProps as O } from "../../helpers/ouia.js";
const _ = ["id"], B = Symbol("SidebarOpenKey"), E = /* @__PURE__ */ l({
  name: "PfPageSidebar",
  __name: "PageSidebar",
  props: {
    id: { default: "page-sidebar" },
    sidebarOpen: { type: Boolean },
    theme: { default: "dark" },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(n) {
    const a = n, p = O({ id: a.ouiaId, safe: a.ouiaSafe }), r = t(g), i = t(v), s = c(() => i != null && i.value ? !!(r != null && r.value) : a.sidebarOpen);
    return m(B, s), (d, K) => (f(), u("div", b(e(p), {
      id: d.id,
      class: [e(o).pageSidebar, {
        [e(o).modifiers.expanded]: s.value,
        [e(o).modifiers.collapsed]: !s.value
      }]
    }), [
      S("div", {
        class: y(e(o).pageSidebarBody)
      }, [
        P(d.$slots, "default")
      ], 2)
    ], 16, _));
  }
});
export {
  B as SidebarOpenKey,
  E as default
};
